import axios from 'axios';
import axiosInstance from './keycloak/axiosInstance';

const apiClient = axiosInstance.create({
  // baseURL: 'https://redoms-backend-dev.m-devsecops.com', 
  headers: {
    'Content-Type': 'application/json',
  },
});

export const submitFormData = async (data) => {
  try {
    const response = await axiosInstance.post('/observation', data);
    return response.data;
  } catch (error) {
    throw error;
  }
};